import type { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import CampusesPage from '@/features/campuses/pages/CampusesPage';
import LoginPage from '@/features/auth/pages/LoginPage';
import ContactMessagesPage from '@/features/contact-messages/pages/ContactMessagesPage';
import DashboardPage from '@/features/dashboard/pages/DashboardPage';
import ModerationPage from '@/features/moderation/pages/ModerationPage';
import NotificationsPage from '@/features/notifications/pages/NotificationsPage';
import PaymentsPage from '@/features/payments/pages/PaymentsPage';
import RentalsPage from '@/features/rentals/pages/RentalsPage';
import SettingsPage from '@/features/settings/pages/SettingsPage';
import UsersListPage from '@/features/users/pages/UsersListPage';
import AuthLayout from '@/layouts/AuthLayout';
import DashboardLayout from '@/layouts/DashboardLayout';
import RequireAuth from '@/routes/guards/RequireAuth';
import RequireRole from '@/routes/guards/RequireRole';
import { ROUTES } from '@/routes/route.config';
import { ADMIN_ROLES } from '@/types/user.types';

const AppRouter: FC = () => (
  <Routes>
    <Route path={ROUTES.root} element={<Navigate to={ROUTES.dashboard} replace />} />

    <Route element={<AuthLayout />}>
      <Route path={ROUTES.login} element={<LoginPage />} />
    </Route>

    <Route element={<RequireAuth />}>
      <Route element={<DashboardLayout />}>
        <Route path={ROUTES.dashboard} element={<DashboardPage />} />
        <Route path={ROUTES.users} element={<UsersListPage />} />
        <Route path={ROUTES.rentals} element={<RentalsPage />} />
        <Route element={<RequireRole roles={ADMIN_ROLES} />}>
          <Route path={ROUTES.moderation} element={<ModerationPage />} />
          <Route path={ROUTES.payments} element={<PaymentsPage />} />
          <Route path={ROUTES.settings} element={<SettingsPage />} />
        </Route>
        <Route path={ROUTES.campuses} element={<CampusesPage />} />
        <Route path={ROUTES.notifications} element={<NotificationsPage />} />
        <Route path={ROUTES.contactMessages} element={<ContactMessagesPage />} />
      </Route>
    </Route>

    <Route path="*" element={<Navigate to={ROUTES.dashboard} replace />} />
  </Routes>
);

export default AppRouter;
